module.exports = __webpack_public_path__ + "assets/55b7169f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dvbt.jpg
// module id = 92
// module chunks = 0